/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAreaStackS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 6.743 16.071 2 7.99 7.052 2 3.458v18.766h20V6.744zM8.01 9.397l7.919-4.95L20 7.706v4.438L16.071 9 7.99 14.052 4 11.658V6.99l4.01 2.407z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartAreaStackS as ChartAreaStackS };
